import React from 'react';
import { Select } from 'src/design/atoms/Select';
import { TextInput } from 'src/design/atoms/TextInput';
import { JobDto } from 'src/api/FiretrolApiClient';
import { StepProps } from './types';

export interface JobStepProps extends StepProps {
  jobs: JobDto[];
  onJobSelect: (job: JobDto | null) => void;
  locked?: boolean;
}

export const JobStep: React.FC<JobStepProps> = ({
  jobs,
  selectedJob,
  onJobSelect,
  setFieldValue,
  locked = false,
}) => {
  const jobData = React.useMemo(() => {
    return jobs.map((job) => ({
      value: String(job.id),
      label: `${job.jobNumber} - ${job.name}`,
    }));
  }, [jobs]);

  const handleChange = (selectedValue: string | null) => {
    const selected = selectedValue
      ? jobs.find((j) => String(j.id) === selectedValue) || null
      : null;
    // The API resolves the daily's WBS accounts from this id, so leaving it at
    // the placeholder from initialValues makes the create call fail.
    setFieldValue('jobId', selected?.id ?? -1);
    onJobSelect(selected);
  };

  if (locked) {
    return (
      <div className="width-400">
        <TextInput
          label="Job"
          description="The job cannot be changed on an existing daily report. Its daily number, attachments and work tickets stay with this job."
          value={
            selectedJob ? `${selectedJob.jobNumber} - ${selectedJob.name}` : ''
          }
          readOnly
          disabled
        />
      </div>
    );
  }

  return (
    <>
      <div className="width-400">
        <Select
          placeholder="Select Job..."
          data={jobData}
          value={selectedJob ? String(selectedJob.id) : null}
          onChange={handleChange}
          clearable={false}
          searchable
        />
      </div>
    </>
  );
};
